export default __webpack_public_path__ + "images/website.3c34ab1ac4d73a57763d1bf72fdb1b43.png";